<!-- 我的页面 -->
<template>
  <a-layout class="app-wrapper">
    <page-sidebar v-show="isSidebar" />
    <a-layout-content class="content-wrapper">
      <page-header />
      <router-view></router-view>
    </a-layout-content>
  </a-layout>
</template>

<script>
import pageHeader from "./header";
import pageSidebar from "./sidebar";

export default {
  name: "Layouot",
  components: {
    pageHeader,
    pageSidebar,
  },
  data() {
    // 这里存放数据
    return {
      collapsed: false
    };
  },
  computed: {
    isSidebar() {
      return this.$route.name !== "manPages";
    },
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    }
  },
  created() {
    this.$saveStoreInstance(this.$store);
  }
};
</script>

<style lang="less">
@import "../../assets/styles/variables.less";
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  background: #F3F6FE!important;
  box-sizing: border-box;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
}
.layout-sider {
  overflow-y: auto;
  overflow-x: hidden;
  background: #F3F6FE!important;
  position: relative;
  .logo {
    padding-left: 24px;
    padding-bottom: 16px;
  }
  .ant-layout-sider {
    background: #F3F6FE;
  }
  .ant-menu {
    background: #F3F6FE!important;
  }
}
.sider-expended {
  padding-left: 24px;
  padding-right: 16px;
  .logo {
    padding: 20px 0px;
  }
}
.content-wrapper {
  background: #FFFFFF;
  border-radius: 16px;
  height: 100%;
  .content-top {
    position: relative;
    padding: 16px 24px;
    padding-bottom: 0;
    .breadcrumb-info {
      height: 32px;
      padding-top: 5.5px;
    }
    .user-info {
      position: absolute;
      right: 24px;
      top: 16px;
      .user-name {
        padding-left: 16px;
        padding-right: 32px;
        background: #F3F6FE;
        display: inline-block;
        min-width: 124px;
        height: 32px;
        vertical-align: middle;
        margin-left: 24px;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        color: @Dark-7;
        position: relative;
        .drop-icon {
          position: absolute;
          right: 12px;
          top: 10px;
        }
      }
    }
  }
}
.user-dropdown {
    box-shadow: 0px 5px 12px 4px rgba(19, 35, 76, 0.09), 0px 3px 6px 0px rgba(19, 35, 76, 0.12), 0px 1px 2px -2px rgba(19, 35, 76, 0.16);
}
</style>
